export enum DeprecatedRpcRoute {
    Dashboard = 'dashboard',
    MyListings = 'my-listings',
    OnMarket = 'on-the-market',
    MyPortfolio = 'my-portfolio',
    MyAppointments = 'my-appointments'
}